import { Descriptions, Space, Tag, notification } from "antd";
import { get } from "lodash";
import { useEffect, useState } from "react";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import Switch from "shared/components/Switch";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";

const STATUS_COLORS = {
  CONFIGURED: "green",
  BUILT_IN: "blue",
  INCOMPLETE: "orange",
  UNCONFIGURED: "default",
  DISABLED: "red",
};

const ConnectorField = ({ value, onChange, labels }) => {
  const { data, refetch } = useQuery(graphql.queries.CONNECTORS);
  const [configureConnector, { loading }] = useMutation(
    graphql.mutations.CONFIGURE_CONNECTOR,
  );
  const [enabled, setEnabled] = useState(true);
  const [appId, setAppId] = useState("");
  const [apiKey, setApiKey] = useState("");

  const connectors = get(data, "connectors") || [];
  const connector = connectors.find((item) => item.key === value) || null;

  useEffect(() => {
    setEnabled(connector ? connector.enabled !== false : true);
    setAppId("");
    setApiKey("");
  }, [connector]);

  const options = connectors.map((item) => ({
    value: item.key,
    label: `${item.label} · ${item.category}`,
  }));

  const save = async () => {
    const config = {};
    if (appId) config.appId = appId;
    if (apiKey) config.apiKey = apiKey;
    const payload = { enabled };
    if (Object.keys(config).length) payload.config = config;
    try {
      await configureConnector({ variables: { key: value, data: payload } });
      notification.success({ message: labels.SAVED });
      refetch();
    } catch (_) {
      notification.error({ message: labels.SAVE_ERROR });
    }
  };

  const masked = connector && connector.hasCredentials ? "••••••" : "";

  return (
    <Space
      direction="vertical"
      size={12}
      className="canvas-editor__full-width"
    >
      <Select
        showSearch
        allowClear
        label={labels.LABEL}
        placeholder={labels.PLACEHOLDER}
        options={options}
        value={value || undefined}
        onChange={(next) => onChange(next || null)}
      />
      {connector ? (
        <div className="canvas-editor__panel">
          <Space
            direction="vertical"
            size={12}
            className="canvas-editor__full-width"
          >
            <div className="canvas-editor__row-between">
              <strong>{connector.label}</strong>
              <Tag color={STATUS_COLORS[connector.status]}>
                {get(labels, `STATUSES.${connector.status}`) ||
                  connector.status}
              </Tag>
            </div>
            <Descriptions column={1} size="small">
              <Descriptions.Item label={labels.VENDOR}>
                {connector.vendor}
              </Descriptions.Item>
              <Descriptions.Item label={labels.DIRECTION}>
                {connector.direction}
              </Descriptions.Item>
              {(connector.configKeys || []).length ? (
                <Descriptions.Item label={labels.CONFIG_KEYS}>
                  {connector.configKeys.map((configKey) => (
                    <Tag key={configKey}>{configKey}</Tag>
                  ))}
                </Descriptions.Item>
              ) : null}
            </Descriptions>
            <div className="canvas-editor__row">
              <Switch checked={enabled} onChange={setEnabled} />
              <span>{labels.ENABLED}</span>
            </div>
            <Input
              label={labels.APP_ID}
              value={appId}
              placeholder={masked}
              onChange={(e) => setAppId(e.target.value)}
            />
            <Input
              label={labels.API_KEY}
              value={apiKey}
              placeholder={masked}
              onChange={(e) => setApiKey(e.target.value)}
            />
            <div className="canvas-editor__row">
              <Button type="primary" onClick={save} disabled={loading}>
                {labels.SAVE}
              </Button>
            </div>
          </Space>
        </div>
      ) : null}
    </Space>
  );
};

export default ConnectorField;
